import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {ApiClientService} from '../../services/api-client.service';

declare const toastr: any;

@Component({
    selector: 'pass-on-log-filter',
    templateUrl: './pass-on-log-filter.component.html',
    styleUrls: ['./pass-on-log-filter.component.scss']
})
export class PassOnLogFilterComponent implements OnInit {
    showDropdown = false;
    @ViewChild('currentCheckbox') current: ElementRef;
    @ViewChild('pastCheckbox') past: ElementRef;
    @ViewChild('futureCheckbox') future: ElementRef;
    @ViewChild('readCheckbox') read: ElementRef;
    @ViewChild('unreadCheckbox') unread: ElementRef;
    constructor(private urlService: UrlService,
                public api: ApiClientService) {
    }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {
            const status = this.urlService.queryParams['status'] ? this.urlService.queryParams['status'].split(',') : [];
            this.current.nativeElement.checked = status.includes('current');
            this.past.nativeElement.checked = status.includes('past');
            this.future.nativeElement.checked = status.includes('future');

            const readStatus = this.urlService.queryParams['readStatus'] ? this.urlService.queryParams['readStatus'].split(',') : [];
            this.unread.nativeElement.checked = readStatus.includes('unread');
            this.read.nativeElement.checked = readStatus.includes('read');
        });
    }

    changeFilter() {
        const currentValue = this.current.nativeElement.checked;
        const pastValue = this.past.nativeElement.checked;
        const futureValue = this.future.nativeElement.checked;
        const readValue = this.read.nativeElement.checked;
        const unreadValue = this.unread.nativeElement.checked;

        if (!currentValue && !pastValue && !futureValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (currentValue) status += 'current,';
            if (pastValue) status += 'past,';
            if (futureValue) status += 'future,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }
        if (!readValue && !unreadValue)
            this.urlService.queryParams['readStatus'] = null;
        else {
            let readStatus = '';
            if (readValue) readStatus += 'read,';
            if (unreadValue) readStatus += 'unread,';
            this.urlService.queryParams['readStatus'] = readStatus.slice(0, -1);
        }
        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('pass-on-log-filter')) this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/pass-on-log-filter/pass-on-log-filter.component.ts